import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import * as MatStyled from "@mui/material/styles";
import styled from "styled-components";
// import styled, { css } from "styled-components";
import dayjs from "dayjs";

import { findAllOrderDraft } from "src/api/saleOrder";

import device from "src/styles/device";
import font from "src/styles/font";
import useDeviceSize from "src/hooks/useDeviceSize";

import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
// import Menu from "@mui/material/Menu";
// import MenuItem from "@mui/material/MenuItem";
// import FormControl from '@mui/material/FormControl';
// import Select from '@mui/material/Select';
// import InputLabel from '@mui/material/InputLabel';
// import MenuItem from '@mui/material/MenuItem';
import { DataGrid, GridActionsCellItem, gridClasses } from "@mui/x-data-grid";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import Button from "src/components/core/Button";

import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useAuth } from "src/hooks/useAuth";
// import ContentCopyIcon from "@mui/icons-material/ContentCopy";
// import FilterAltIcon from "@mui/icons-material/FilterAlt";

const DivMuiContainer = styled.div`
  width: 100%;
  height: auto;
  padding: 32px;
  border-radius: 32px;
  background-color: #ffffff;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
  // display: flex;
  justify-content: center;
  align-items: center;

  @media ${device.tabletL} {
    padding: 0;
    border-radius: 0;
    box-shadow: none;
  }
`;

const DivMuiInside = styled.div`
  width: 100%;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
`;

const WrapperSearch = styled.div`
  // margin-bottom: 32px;
  margin-right: 16px;
  width: 65%;
  position: relative;
  display: flex;
  justify-content: center;

  @media ${device.tabletL} {
    width: 70%;
    /* margin-right: 4px; */
  }
  @media ${device.tablet} {
    width: 65%;
    /* margin-right: 4px; */
  }
  @media ${device.mobileL} {
    width: 85%;
  }

  .TextField-without-border-radius fieldset {
    border-radius: 16px;
  }
  .MuiTextField-root {
    margin: 0;
  }
`;

// const WrapperIcon = styled.div`
//   /* display: flex;
//   flex-direction: column;
//   justify-content: center;
//   align-items: center; */
//   padding: 0px;
//   width: max-content;
//   max-width: 5%;
//   margin: 0 auto;

//   @media ${device.tabletL} {
//     /* width: 5%; */
//     max-width: 32px;
//   }
// `;

const WrapperButton = styled.div`
  /* display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center; */
  padding: 0px;
  width: 35%;
  max-width: 350px;
  margin-left: 16px;

  @media ${device.tabletL} {
    width: 30%;
    /* margin-left: 12px; */
  }
  @media ${device.tablet} {
    width: 35%;
    /* margin-left: 12px; */
  }
  @media ${device.mobileL} {
    width: max-content;
    max-width: 32px;
    margin-left: 14px;
  }

  .Button-Add {
    width: 100%;
    box-shadow:
      0px 3px 1px -2px rgba(0, 0, 0, 0.2),
      0px 2px 2px rgba(0, 0, 0, 0.14),
      0px 1px 5px rgba(0, 0, 0, 0.12);
    border-radius: 16px;
    height: 52px;
    padding: 12px 24px;
  }
  .Button-Add:focus {
    background-color: #e04132;
  }
  .Button-Add:hover {
    background-color: #e04132;
    opacity: 0.9;
  }
`;

// const WrapperTextfield = styled.div`
//   /* width: ${({ half }) => (half ? "48.5%" : "100%")}; */
//   width: max-content;

//   @media ${device.tabletL} {
//     max-width: ${({ half }) => (half ? "250px" : "530px")};

//     ${({ left, right }) =>
//       left
//         ? css`
//             margin-left: auto;
//           `
//         : right
//         ? css`
//             margin-right: auto;
//           `
//         : css`
//             margin: 0 auto;
//           `}
//   }

//   .TextField-without-border-radius fieldset {
//     border-radius: 24px;
//     // text-align: center;
//     // background: #fff;
//   }
//   .TextField-without-border-radius-amount fieldset {
//     border-radius: 24px;
//     width: 100%;
//     text-align: center;
//     background: #fff;
//   }
//   .MuiAutocomplete-root {
//     /* margin: ${({ item }) => (item ? "0" : "24px 0")}; */
//     margin: 0;
//   }
//   .MuiOutlinedInput-input {
//     background: #fff;
//     /* border-radius: 24px; */
//     /* padding: 16px 14px; */
//   }
//   .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-formControl {
//     padding-right: 14px;
//   }
//   .MuiInputBase-root-MuiOutlinedInput-root {
//     border-radius: 24px;
//     background: #fff;
//   }
//   .MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root {
//     border-radius: 24px;
//   }

//   .MuiTextField-root {
//     border-radius: 24px;
//   }
//   .MuiOutlinedInput-root {
//     border-radius: 24px;
//   }
//   .MuiAutocomplete-root .MuiOutlinedInput-root .MuiAutocomplete-input {
//     padding: 7.5px 0
//   }
// `;

const DivFilterSection = styled.div`
  width: 100%;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const WrapperDataGrid = styled.div`
  height: 600px;
  width: 100%;
  background: var(--white-color);

  .MuiDataGrid-root {
    border: 1px solid #ffffff;
  }
  .MuiDataGrid-columnHeaders {
    background-color: #f5f5f5;
  }
  .MuiDataGrid-root .MuiDataGrid-columnSeparator--sideRight {
    color: #f5f5f5;
  }
  .MuiDataGrid-root .MuiDataGrid-columnHeader:focus-within {
    // outline: solid #f5f5f5 1px;
    outline: none;
  }
  .MuiDataGrid-root .MuiDataGrid-cell:focus {
    outline: none;
    border-bottom: solid #f5f5f5 1px 0 1px 0;
  }
  .MuiDataGrid-root .MuiDataGrid-row.Mui-selected {
    background-color: #ffffff;
  }

  @media ${device.tabletL} {
    height: 70dvh;
    border-radius: 24px;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);

    .MuiDataGrid-root {
      border-radius: 16px;
    }
    .MuiDataGrid-columnHeaders {
      border-radius: 16px 16px 0 0;
    }
    .MuiDataGrid-columnHeader:first-child,
    .MuiDataGrid-cell:first-child {
      padding-left: 32px;
    }
    .MuiDataGrid-columnHeader:last-child,
    .MuiDataGrid-cell:last-child {
      padding-right: 32px;
    }
  }
  @media ${device.mobileL} {
    border-radius: 16px;

    .MuiDataGrid-root {
      border-radius: 16px;
    }
    .MuiDataGrid-columnHeaders {
      border-radius: 16px 16px 0 0;
    }
    .MuiDataGrid-columnHeader:first-child,
    .MuiDataGrid-cell:first-child {
      padding-left: 16px;
    }
    .MuiDataGrid-columnHeader:last-child,
    .MuiDataGrid-cell:last-child {
      padding-right: 16px;
    }
  }
`;

const ImageNoData = styled.image`
  width: 120px;
  height: 120px;
  background-image: url("https://xsurface-images.s3.ap-southeast-1.amazonaws.com/no+data.svg");
  background-repeat: no-repeat;
  background-size: 100%;
`;

const ImageNotFound = styled.image`
  width: 120px;
  height: 120px;
  background-image: url("https://xsurface-images.s3.ap-southeast-1.amazonaws.com/not+found.svg");
  background-repeat: no-repeat;
  background-size: 100%;
`;

const TextNoData = styled.pre`
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
`;

const drawerWidth = 260;

const Main = MatStyled.styled("main", {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  position: "relative",
  flexGrow: 1,
  padding: "16px 20px",
  [theme.breakpoints.up("sm")]: {
    padding: "24px 40px",
  },
  [theme.breakpoints.down("sm")]: {
    marginTop: "64px",
    height: "calc(100vh - 64px)",
  },
  [theme.breakpoints.up("md")]: {
    padding: theme.spacing(3),
  },
  transition: theme.transitions.create("margin", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  marginLeft: `-${drawerWidth}px`,
  width: "100%",
  marginTop: "75px",
  background: "#fff",
  ...(open && {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
    position: "relative",
  }),
}));

const SaleOrderList = ({ open }) => {
  const { user, checkAllowPermission } = useAuth();

  const navigate = useNavigate();
  const [quotationDraftList, setQuotationDraftList] = useState([]);
  // const [salesList, setSalesList] = useState([
  //   {
  //     label: "Namfon",
  //     value: "Namfon",
  //   },
  //   {
  //     label: "Aungaing",
  //     value: "Aungaing",
  //   },
  // ]) // ? Mock data

  const [dataSearch, setDataSearch] = useState({
    keyword: null,
    filter: "all",
    page: 0,
    page_size: 10,
  });
  const [rowCount, setRowCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const [deviceWidth] = useDeviceSize();

  // const [anchorEl, setAnchorEl] = useState(null);
  // const openFilter = Boolean(anchorEl);
  // const handleClickFilter = (event) => {
  //   setAnchorEl(event.currentTarget);
  // };
  // const handleCloseFilter = () => {
  //   setAnchorEl(null);
  // };

  const DesktopColumns = [
    {
      field: "createdAt",
      headerName: "Date",
      flex: 1.1,
      headerAlign: "left",
      align: "left",
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <Box
            sx={{
              // width: "100%",
              wordWrap: "break-word",
              py: 2,
            }}
          >
            {params?.row?.createdAt
              ? dayjs(params?.row?.createdAt).format("DD-MM-YYYY")
              : "-"}
          </Box>
        );
      },
    },
    {
      field: "running_number",
      headerName: "Sale Order No.",
      flex: 1.5,
      // width: 200,
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <Box
            sx={{
              width: "100%",
              wordWrap: "break-word",
              py: 2,
            }}
          >
            {params?.row?.running_number}
          </Box>
        );
      },
    },
    {
      field: "ref_quotation",
      headerName: "Quotation No.",
      flex: 1.5,
      // width: 200,
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <Box
            sx={{
              width: "100%",
              wordWrap: "break-word",
              py: 2,
            }}
          >
            {!!params?.row?.ref_quotation ? params?.row?.ref_quotation : "-"}
          </Box>
        );
      },
    },
    {
      field: "customer_name",
      headerName: "Name",
      flex: 1.5,
      // width: 200,
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <Box
            sx={{
              width: "100%",
              wordWrap: "break-word",
              py: 2,
            }}
          >
            {params?.row?.customer_name}
          </Box>
        );
      },
    },
    {
      field: "sale_code", // ? Not sure
      headerName: "Sale",
      flex: 1.5,
      // width: 200,
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <Box
            sx={{
              width: "100%",
              wordWrap: "break-word",
              py: 2,
            }}
          >
            {!!params?.row?.created_by?.user_name
              ? params?.row?.created_by?.user_name
              : "-"}
          </Box>
        );
      },
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      // width: 200,
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <Box
            sx={{
              width: "100%",
              wordWrap: "break-word",
              py: 2,
              ...(params?.row?.status === "available" && {
                color: "var(--blue-color)",
              }),
              ...(params?.row?.status === "timeout" && {
                color: "var(--primary-color)",
              }),
            }}
          >
            {params?.row?.status === "available"
              ? "ออเดอร์อยู่ในเวลา"
              : params?.row?.status === "timeout"
                ? "คำสั่งซื้อหมดเวลา"
                : params?.row?.status}
          </Box>
        );
      },
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Action",
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      getActions: (params) => [
        <GridActionsCellItem
          icon={<EditRoundedIcon />}
          label="Edit"
          // disabled={params.row.status !== 0 ? true : false}
          disabled={!checkAllowPermission("sale_features.can_create_saleOrder")}
          onClick={() => navigate(`/sale-order/edit/${params.row._id}`)}
          showInMenu
        />,
        // <GridActionsCellItem
        //   icon={<ContentCopyIcon />}
        //   label="Copy Order"
        //   // disabled={params.row.status !== 0 ? true : false}
        //   // onClick={() => navigate(`/sale-order/detail/${params.row._id}`)}
        //   showInMenu
        // />,
        <GridActionsCellItem
          icon={<VisibilityIcon />}
          label="Detail"
          onClick={() => navigate(`/sale-order/detail/${params.row._id}`)}
          showInMenu
        />,
      ],
    },
  ];

  const MobileColumns = [
    {
      field: "createdAt", // ?
      headerName: "Date",
      flex: 2,
      // width: 200,
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <Box
            sx={{
              width: "100%",
              wordWrap: "break-word",
              py: 2,
            }}
          >
            {params?.row?.createdAt
              ? dayjs(params?.row?.createdAt).format("DD-MM-YYYY")
              : "-"}
          </Box>
        );
      },
    },
    {
      field: "customer_name",
      headerName: "Name",
      flex: 2,
      // width: 200,
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <Box
            sx={{
              width: "100%",
              wordWrap: "break-word",
              py: 2,
              ...(params?.row?.status === "available" && {
                color: "var(--blue-color)",
              }),
              ...(params?.row?.status === "timeout" && {
                color: "var(--primary-color)",
              }),
            }}
          >
            {params?.row?.customer_name}
          </Box>
        );
      },
    },
    {
      field: "actions",
      type: "actions",
      headerName: "",
      flex: 0.5,
      sortable: false,
      disableColumnMenu: true,
      getActions: (params) => [
        <GridActionsCellItem
          icon={<EditRoundedIcon />}
          label="Edit"
          disabled={params.row.status !== 0 ? true : false}
          // disabled={params.row.status === 2 ? true : false}
          onClick={() => navigate(`/sale-order/edit/${params.row._id}`)}
          showInMenu
        />,
        <GridActionsCellItem
          icon={<VisibilityIcon />}
          label="Detail"
          onClick={() => navigate(`/sale-order/detail/${params.row._id}`)}
          showInMenu
        />,
      ],
    },
  ];

  const NoRowsOverlay = () => {
    return (
      <Stack height="100%" alignItems="center" justifyContent="center">
        <ImageNoData></ImageNoData>
        <TextNoData>No Data</TextNoData>
      </Stack>
    );
  };

  const NoResultsOverlay = () => {
    return (
      <Stack height="100%" alignItems="center" justifyContent="center">
        <ImageNotFound></ImageNotFound>
        <TextNoData>Not Found</TextNoData>
      </Stack>
    );
  };

  const onSearchButton = (key, filter) => {
    setDataSearch({ ...dataSearch, [key]: filter, page: 0 });
    setIsLoading(true);
    (async () => {
      if (user.role_id === 1) {
        const { data } = await findAllOrderDraft({
          ...dataSearch,
          [key]: filter,
          page: 0,
        });
        setQuotationDraftList(data.rows);
        setRowCount(data.count);
        setIsLoading(false);
      }
    })();
  };

  const handlePageChange = (newPage) => {
    // We have the cursor, we can allow the page transition.
    setDataSearch({ ...dataSearch, page: newPage });
  };

  useEffect(() => {
    setIsLoading(true);
    (async () => {
      if (user.role_id === 1) {
        const { data } = await findAllOrderDraft(dataSearch);
        setQuotationDraftList(data.rows);
        setRowCount(data.count);
        setIsLoading(false);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataSearch.page]);

  return (
    <Main open={open}>
      <DivMuiContainer>
        <DivMuiInside>
          <WrapperSearch>
            <TextField
              id="search-input"
              placeholder="ค้นจากรหัสสินค้าชื่อลูกค้า"
              className="TextField-without-border-radius"
              sx={{
                m: 1,
                width: "100%",
                borderRadius: "16px",
              }}
              InputProps={{
                endAdornment: (
                  <IconButton
                    id="button-search-quotation"
                    sx={{ padding: 0 }}
                    onClick={() => onSearchButton()}
                  >
                    <SearchIcon sx={{ color: "#e04132", cursor: "pointer" }} />
                  </IconButton>
                ),
              }}
              onChange={(e) => {
                setDataSearch({ ...dataSearch, keyword: e.target.value });
              }}
              onKeyUp={(e) => (e.code === "Enter" ? onSearchButton() : null)}
            />
          </WrapperSearch>

          {/* <WrapperIcon>
            <IconButton
              id="filter-button"
              aria-label="filter"
              aria-controls={openFilter ? "basic-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={openFilter ? "true" : undefined}
              sx={{
                width: "32px",
                height: "32px",
                backgroundColor: "var(--darkwhite-color)",
                color: "var(--secondary-color)",
              }}
              onClick={handleClickFilter}
            >
              <FilterAltIcon sx={{ fontSize: 16 }} />
            </IconButton>
            <Menu
              id="filter-menu"
              anchorEl={anchorEl}
              open={openFilter}
              onClose={handleCloseFilter}
              MenuListProps={{
                "aria-labelledby": "filter-button",
              }}
              sx={{
                mt: 2,
                ".MuiMenu-paper": {
                  borderRadius: 6,
                },
                ".MuiMenu-list": {
                  p: 0,
                },
                ".MuiMenuItem-root": {
                  px: 3,
                  py: 1,
                  ":first-child": {
                    pt: 2,
                  },
                  ":last-child": {
                    pb: 2,
                  },
                },
              }}
              transformOrigin={{ horizontal: "center", vertical: "top" }}
              anchorOrigin={{ horizontal: "center", vertical: "bottom" }}
            >
              <MenuItem
                onClick={() => {
                  onSearchButton("status", "draft");
                }}
              >
                Draft Quotation
              </MenuItem>
              <MenuItem
                onClick={() => {
                  onSearchButton("status", "complete");
                }}
              >
                Complete Quotation
              </MenuItem>
            </Menu>
          </WrapperIcon> */}

          {checkAllowPermission("sale_features.can_create_saleOrder") && (
            <WrapperButton>
              {deviceWidth > 540 ? (
                <Button
                  variant="contained"
                  className="Button-Add"
                  sx={{
                    width: "100%",
                    maxWidth: 350,
                    fontSize: font.size.sm,
                  }}
                  startIcon={<AddIcon />}
                  onClick={() => navigate("/sale-order/create")}
                >
                  สร้างออเดอร์
                </Button>
              ) : (
                <IconButton
                  sx={{
                    width: "32px",
                    height: "32px",
                    backgroundColor: "var(--primary-color)",
                    color: "var(--white-color)",
                  }}
                  onClick={() => navigate("/sale-order/create")}
                >
                  <AddIcon sx={{ fontSize: 16 }} />
                </IconButton>
              )}
            </WrapperButton>
          )}
        </DivMuiInside>

        {deviceWidth > 835 && (
          <DivFilterSection>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography
                sx={{
                  mr: 2,
                }}
                component="span"
              >
                ทั้งหมด :{" "}
                <Typography
                  component="span"
                  sx={{
                    color: "#E13B30",
                  }}
                >
                  {rowCount}
                </Typography>
              </Typography>
            </Box>

            {/* <Box
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography
                sx={{
                  mr: 1,
                }}
                component="span"
              >
                Sale :
              </Typography>
              <FormControl
                sx={{
                  mx: 1,
                  minWidth: 120,
                  ".MuiFormLabel-root": {
                    color: "var(--primary-color)",
                  }
                }}
                size="small"
              >
                <InputLabel id="sales-select-label">All sales</InputLabel>
                <Select
                  labelId="sales-select-label"
                  id="sales-select"
                  // value={age}
                  label="All sales"
                  onChange={(e) => onSearchButton("sale", e.target.value)}
                >
                  <MenuItem value="">All</MenuItem>
                  {salesList.map((sale, i) => (
                    <MenuItem key={`sale-${i}`} value={sale.value}>{sale.label}</MenuItem>
                  ))}
                </Select>
              </FormControl>

              <Typography
                sx={{
                  mr: 1,
                }}
                component="span"
              >
                From :
              </Typography>
              <WrapperTextfield>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label="Date"
                    inputFormat="DD/MM/YYYY"
                    // value={formData?.document_date}
                    // onChange={(newValue) =>
                    //   onChange(null, `document_date`, newValue)
                    // }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        sx={{
                          // my: 2,
                          width: "100%",
                          maxWidth: "150px",
                          background: "#fff",
                          ".MuiOutlinedInput-root": {
                            paddingRight: "18px",
                          },
                        }}
                      />
                    )}
                  />
                </LocalizationProvider>
              </WrapperTextfield>
              <Typography
                sx={{
                  mx: 1,
                }}
                component="span"
              >
                to
              </Typography>
              <WrapperTextfield>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label="Date"
                    inputFormat="DD/MM/YYYY"
                    // value={formData?.document_date}
                    // onChange={(newValue) =>
                    //   onChange(null, `document_date`, newValue)
                    // }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        sx={{
                          // my: 2,
                          width: "100%",
                          maxWidth: "150px",
                          background: "#fff",
                          ".MuiOutlinedInput-root": {
                            paddingRight: "18px",
                          },
                        }}
                      />
                    )}
                  />
                </LocalizationProvider>
              </WrapperTextfield>
            </Box> */}
          </DivFilterSection>
        )}

        <WrapperDataGrid>
          <DataGrid
            rows={quotationDraftList}
            getRowId={(row) => row._id}
            getRowHeight={() => "auto"}
            loading={isLoading}
            columns={deviceWidth > 835 ? DesktopColumns : MobileColumns}
            pageSize={10}
            rowCount={rowCount}
            paginationMode="server"
            page={dataSearch.page}
            onPageChange={(e) => handlePageChange(e)}
            rowsPerPageOptions={[10]}
            pagination
            disableSelectionOnClick
            components={{
              // Footer: CustomPagination,
              NoRowsOverlay,
              NoResultsOverlay,
            }}
            componentsProps={{
              basePopper: {},
            }}
            sx={{
              [`& .${gridClasses.row}.odd`]: {
                backgroundColor: "var(--darkwhite-color)",
                "&:hover": {
                  backgroundColor: "#f3f1f269",
                  "@media (hover: none)": {
                    backgroundColor: "transparent",
                  },
                },
              },
              "& .MuiDataGrid-actionsCell": {
                transform: "rotate(90deg)",
              },
              ".MuiDataGrid-row": {
                minHeight: {
                  xs: "60px !important",
                  md: "80px !important",
                },
              },
            }}
            getRowClassName={(params) =>
              params.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd"
            }
          />
        </WrapperDataGrid>
      </DivMuiContainer>
    </Main>
  );
};

export default SaleOrderList;
